import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const RequireAuth = ({ children }) => {
    const { user, isLoading } = useContext(AuthContext);
    const location = useLocation();

    // 1. First, and most importantly, show a loading indicator while the
    // AuthContext is determining the user's authentication status.
    if (isLoading) {
        return (
            <div className='d-flex justify-content-center align-items-center' style={{ minHeight: '100vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    // 2. After the loading is complete, if there is still no user,
    // it's safe to redirect to the login page.
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 3. If a user exists but has no active subscription, redirect them to select a plan.
    // We also add a check to PREVENT a redirect loop if they are already on the select-plan page.
    if (!user.has_active_subscription && location.pathname !== '/club_portal/select-plan') {
      console.log(" i am entering inside");
      
        return <Navigate to="/club_portal/select-plan" state={{ from: location }} replace />;
    }
    
    // 4. If all checks pass, the user is authenticated and has a subscription,
    // so we render the requested component.
    return children;
};

export default RequireAuth;

